import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

import DeleteIcon from "@material-ui/icons/Delete";

import Divider from "@material-ui/core/Divider";

import "./usersList.css";

import React, { useState } from "react";

const UseListComponent = ({ users }) => {
  const { data, id } = users;

  return (
    <>
      <Divider></Divider>
      <List>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <PersonRoundedIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={`Name: ${data.name}`}
            secondary={`email: ${data.email}`}
          />
          <ListItemText primary={`phone: ${data.phone}`} />
          <ListItemSecondaryAction>
            <IconButton edge="end" aria-label="delete">
              <DeleteIcon color="error" fontSize="large" />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      </List>
      <Divider></Divider>
    </>
  );
};

export default UseListComponent;
